// Match $zIndexModal in src/styles/variables/_zIndex.scss
const PERSON_COVERAGE_MODAL_OVERLAY_Z_INDEX = 1200
const PERSON_COVERAGE_MODAL_CONTENT_Z_INDEX = 1201

export const PERSON_COVERAGE_MODAL_STYLE = {
  overlay: {
    zIndex: PERSON_COVERAGE_MODAL_OVERLAY_Z_INDEX,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    overflowY: 'auto',
    background: 'rgba(40, 48, 54, 0.8)',
    padding: '16px',
  },
  content: {
    zIndex: PERSON_COVERAGE_MODAL_CONTENT_Z_INDEX,
    position: 'relative',
    inset: 'unset',
    top: 'unset',
    right: 'unset',
    bottom: 'unset',
    left: 'unset',
    width: '100%',
    maxWidth: '568px',
    maxHeight: 'calc(100dvh - 32px)',
    margin: '0',
    backgroundColor: '#fff',
    border: '0',
    borderRadius: '6px',
    overflow: 'auto',
    flexShrink: 0,
  },
}
